const ConnectWiseUsersMappings = () => import('@/views/account/integrations/connectwise/mappings/connectwise-users-mappings-view.vue');
const ConnectWiseCompaniesMappings = () => import('@/views/account/integrations/connectwise/mappings/connectwise-companies-mappings-view.vue');
const ConnectWiseContactsMappings = () => import('@/views/account/integrations/connectwise/mappings/connectwise-contacts-mappings-view');
const ConnectWiseSolutionsMappings = () => import('@/views/account/integrations/connectwise/mappings/connectwise-solutions-mappings-view');
const ConnectWiseActivitiesMappings = () => import('@/views/account/integrations/connectwise/mappings/connectwise-activities-mappings-view');
const ConnectWiseOpportunitiesMappings = () => import('@/views/account/integrations/connectwise/mappings/connectwise-opportunities-mappings-view');

import store from '@/stores/index';

export default [
    {
        path: '/Integrations/ConnectWise/Manage/Users/Mappings',
        name: 'ConnectWiseUsersMappings',
        component: ConnectWiseUsersMappings,
        props: true,
        meta: {
            isUiShown: true,
            subtype: 'account'
        },
        beforeEnter: (to, from, next) => {
            if (!store.getters.isAdmin) {
                next('/Unauthorized');
            } else {
                next();
            }
        }
    },
    {
        path: '/Clients/:clientId/Integrations/ConnectWise/Manage/Users/Mappings',
        name: 'ClientConnectWiseUsersMappings',
        component: ConnectWiseUsersMappings,
        props: true,
        meta: {
            isUiShown: true,
            subtype: 'account'
        }
    },
    {
        path: '/Integrations/ConnectWise/Manage/Companies/Mappings',
        name: 'ConnectWiseCompaniesMappings',
        component: ConnectWiseCompaniesMappings,
        props: true,
        meta: {
            isUiShown: true,
            subtype: 'account'
        },
        beforeEnter: (to, from, next) => {
            if (!store.getters.isAdmin) {
                next('/Unauthorized');
            } else {
                next();
            }
        }
    },
    {
        path: '/Clients/:clientId/Integrations/ConnectWise/Manage/Companies/Mappings',
        name: 'ClientConnectWiseCompaniesMappings',
        component: ConnectWiseCompaniesMappings,
        props: true,
        meta: {
            isUiShown: true,
            subtype: 'account'
        }
    },
    {
        path: '/Integrations/ConnectWise/Manage/Contacts/Mappings',
        name: 'ConnectWiseContactsMappings',
        component: ConnectWiseContactsMappings,
        props: true,
        meta: {
            isUiShown: true,
            subtype: 'account'
        },
        beforeEnter: (to, from, next) => {
            if (!store.getters.isAdmin) {
                next('/Unauthorized');
            } else {
                next();
            }
        }
    },
    {
        path: '/Clients/:clientId/Integrations/ConnectWise/Manage/Contacts/Mappings',
        name: 'ClientConnectWiseContactsMappings',
        component: ConnectWiseContactsMappings,
        props: true,
        meta: {
            isUiShown: true,
            subtype: 'account'
        }
    },
    {
        path: '/Integrations/ConnectWise/Manage/Solutions/Mappings',
        name: 'ConnectWiseSolutionsMappings',
        component: ConnectWiseSolutionsMappings,
        props: true,
        meta: {
            isUiShown: true,
            subtype: 'account'
        },
        beforeEnter: (to, from, next) => {
            if (!store.getters.isAdmin) {
                next('/Unauthorized');
            } else {
                next();
            }
        }
    },
    {
        path: '/Clients/:clientId/Integrations/ConnectWise/Manage/Solutions/Mappings',
        name: 'ClientConnectWiseSolutionsMappings',
        component: ConnectWiseSolutionsMappings,
        props: true,
        meta: {
            isUiShown: true,
            subtype: 'account'
        }
    },
    {
        path: '/Integrations/ConnectWise/Manage/Activities/Mappings',
        name: 'ConnectWiseConnectWiseActivitiesMappings',
        component: ConnectWiseActivitiesMappings,
        props: true,
        meta: {
            isUiShown: true,
            subtype: 'account'
        },
        beforeEnter: (to, from, next) => {
            if (!store.getters.isAdmin) {
                next('/Unauthorized');
            } else {
                next();
            }
        }
    },
    {
        path: '/Clients/:clientId/Integrations/ConnectWise/Manage/Activities/Mappings',
        name: 'ClientConnectWiseActivitiesMappings',
        component: ConnectWiseActivitiesMappings,
        props: true,
        meta: {
            isUiShown: true,
            subtype: 'account'
        }
    },
    {
        path: '/Integrations/ConnectWise/Manage/Opportunities/Mappings',
        name: 'ConnectWiseOpportunitiesMappings',
        component: ConnectWiseOpportunitiesMappings,
        props: true,
        meta: {
            isUiShown: true,
            subtype: 'account'
        },
        beforeEnter: (to, from, next) => {
            if (!store.getters.isAdmin) {
                next('/Unauthorized');
            } else {
                next();
            }
        }
    },
    {
        path: '/Clients/:clientId/Integrations/ConnectWise/Manage/Opportunities/Mappings',
        name: 'ClientConnectWiseOpportunitiesMappings',
        component: ConnectWiseOpportunitiesMappings,
        props: true,
        meta: {
            isUiShown: true,
            subtype: 'account'
        }
    }
]